module.exports = __webpack_public_path__ + "media/images/seeds/botez-c5a40393a40f7be0473e7eb8a32ee2f5.jpeg";